import { jsxs as e, jsx as s } from "react/jsx-runtime";
import { forwardRef as v } from "react";
import { S as N } from "../typography/Typography-CXNJ1SFo.mjs";
import "../icons/HeartToggle-Bwgo4FxH.mjs";
import { b as l, c as b, a as P } from "../icons/Icons-CVv5JxOX.mjs";
const y = "_rds-panel_297es_1", A = "_content-and-buttons_297es_34", S = "_content_297es_34", j = "_title_297es_60", k = "_icon_297es_68", x = "_buttons_297es_75", n = {
  rdsPanel: y,
  contentAndButtons: A,
  content: S,
  title: j,
  icon: k,
  buttons: x
}, B = {
  error: {
    title: "Feil",
    icon: /* @__PURE__ */ s(l, {})
  },
  info: {
    title: "Informasjon",
    icon: /* @__PURE__ */ s(l, {})
  },
  success: {
    title: "Vellykket",
    icon: /* @__PURE__ */ s(b, {})
  },
  warning: {
    title: "Advarsel",
    icon: /* @__PURE__ */ s(P, {})
  }
}, C = v(
  ({ className: r = "", intent: o = "info", heading: t, action: c, id: i, children: a, ..._ }, m) => {
    const { title: p, icon: d } = B[o], f = typeof t == "string" ? t : (t == null ? void 0 : t.title) ?? p, u = typeof t == "string" ? "span" : (t == null ? void 0 : t.level) ?? "span";
    return /* @__PURE__ */ e(
      "div",
      {
        id: i,
        className: `${n.rdsPanel} ${r}`,
        "data-testid": "rds-panel",
        "data-intent": o,
        ref: m,
        ..._,
        children: [
          /* @__PURE__ */ s("span", { className: n.icon, children: d }),
          /* @__PURE__ */ e("div", { className: n.contentAndButtons, children: [
            /* @__PURE__ */ e("div", { className: n.content, children: [
              /* @__PURE__ */ s(u, { className: `${n.title} rds-title-4`, children: f }),
              /* @__PURE__ */ s(N, { children: a })
            ] }),
            c && /* @__PURE__ */ s("div", { className: n.buttons, children: c })
          ] })
        ]
      }
    );
  }
);
C.displayName = "Panel";
export {
  C as P
};
